export default (props) => {
  // console.log(props);
  return <h1>Not Found ({props.location.pathname})</h1>;
};
